<template>
  <closable-card :title="'À propos'">
    <h2>Learn and Watch</h2>
    <p>Les séries et films font partis des meilleurs moyens pour améliorer la compréhension des langues étrangères.
        <br>La plupart des étudiants sont cependant sujets à des freins qui les empêchent de regarder les séries en version originale sous titrée en anglais (VOST). </p>

    <div class="approche">
        <div>
            <p>Nous utilisons une approche scientifique visant à retirer les freins suivants</p>
            <ul>
                <li>Choix de série non adapté</li>
                <ul>
                    <li>Série dense et provoquant une fatigue rapide</li>
                    <li>Série contenant beaucoup de jeux de mots</li>
                </ul>
                <li>Niveau en anglais insuffisant</li>
                <ul>
                    <li>Manque de vocabulaire clé rendant la compréhension plus difficile</li>
                    <li>Manque de connaissance du contexte, altérant la compréhension du sens des mots</li>
                </ul>
                <li>Vitesse de lecture insuffisante</li>

            </ul>
            <p>Nous créons du contenu pour diriger l’utilisateur vers des séries adaptées et lui donner des outils et du contexte, lui facilitant ainsi le visionnages d’épisodes en VOST.
                </p>
        </div>
        <div>
            <p>Nous nous assurons du bien-fondé de cette approche en utilisant les résultats des études suivantes afin de guider le développement de l’outil:</p>
            <ul style="font-style: italic; ">
                <li>
                    Rodgers, Michael PH. "English language learning through viewing television: An investigation of comprehension, incidental vocabulary acquisition, lexical coverage, attitudes, and captions." (2013).
                </li>
                <li>
                    Nation, Paul. "The four strands." International Journal of Innovation in Language Learning and Teaching (2007).
                </li>
                <li>
                    Rahimi, Mehrak, and Maral Katal. "Metacognitive strategies awareness and success in learning English as a foreign language: an overview." Procedia-Social and Behavioral Sciences (2012).
                </li>
                <li>
                    Goundar, Prashneel Ravisan. "Vocabulary learning strategies of english as foreign language (efl) learners: A literature review."
                </li>
            </ul>
        </div>
    </div>
    <h2 style="margin-top: 0.5vw">L’équipe
    </h2>
    <div class="equipe">
        <div class="profile_pic" :style="{backgroundImage: 'url(' + require('../assets/romain.jpg') + ')'}">
        </div>
        <div class="role">
            <h3>Romain Destenay</h3>
            Co-fondateur
            <br>CEO / CTO
            <br>Développeur Full-Stack
        </div>
        <div class="profile_pic" :style="{backgroundImage: 'url(' + require('../assets/jeremy.jpg') + ')'}">
        </div>
        <div class="role">
            <h3>Jeremy Batbedat</h3>
            Co-fondateur
            <br>Développeur Front-End
            <br>Chargé de la gamification
        </div>
    </div>

    <h2 style="margin-top: 2.5vw">Remerciements
    </h2>
    <div style="display: grid; grid-template-columns: 1fr 1fr; grid-template-rows: auto auto; grid-column-gap: 2vw">
        <img :src="require('../assets/tvdb.png')" class="logoTVDB">
        <img :src="require('../assets/opensub.webp')" class="logoOpenSub">
        <div>
            <p>
                Les images sont fournies par <a href="https://www.thetvdb.com" target="_blank">TheTVDB.com</a>, mais nous ne sommes pas cautionnés ni certifiés par TheTVDB.com ou ses affiliés. <br/>(TV information and images are provided by TheTVDB.com, but we are not endorsed or certified by TheTVDB.com or its affiliates.)
            </p>
        </div>
        <div>
            <p>
                Les sous titres utiles à l'extraction de vocabulaire pertinent ont globalement été fournis par <a href="https://www.opensubtitles.org/fr" target="_blank">OpenSubtitles.org</a>.<br/> Nous les en remercions.
            </p>
        </div>
      <hr><hr>
      <a href="https://www.freepik.com/vectors/background">Background vector created by freepik - www.freepik.com</a>
    </div>

  </closable-card>

</template>

<script>

  import {mapGetters} from "vuex";

  export default {
		name: "about",
    components: {closableCard: () => import(/* webpackPrefetch: true */ '@/components/closableCard.vue')
    },
    methods: {
        quit: function () {
            this.$emit('quitev')
        },
    },
    computed: {
      ...mapGetters('global', [
        'isMobile',
      ]),
    },
	}
</script>

<style scoped>
        .approche{
            display: flex;
            flex-direction: column;
            justify-content: flex-start;
            align-content: flex-start;
        }

        .equipe{
            display: grid;
            grid-template-columns: auto  1fr;
            grid-template-rows: auto auto;
            grid-column-gap: 5vw;
            align-items: flex-start;
            justify-items: flex-start;
        }

        .profile_pic{
            width: 75px;
            height: 75px;
            border-radius: 10px;
            background-size: cover;
        }

        .role{
            margin-bottom: 25px;
        }

        .logoTVDB{
            height: 40px;
        }

        .logoOpenSub{
            height: 40px;
        }
</style>